import React, { useState } from 'react'
import { DateInput, ModalWrapper, StyledButton, TextFields } from '../../../../../../components'
import { Typography } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { setLoader, setRefreshPage } from '../../../../../../redux/globalSlice'
import { baseURL, urls } from '../../../../../../shared/config'
import { toast } from 'react-toastify'
import axios from 'axios'

export const formatDate = (dateString) => {
  const [year, month, day] = dateString.split(/-|T/)
  return `${year}-${month}-${day}`
}

export const EditHoliday = ({ open, handleClose }) => {
  const data = useSelector((state) => state.global.SchoolDInfo)
  const HolidayId = useSelector((state) => state.global.holiday_id)

  const dispatch = useDispatch()
  const initialValues = useState({
    name: '',
    date: '',
  })
  React.useEffect(() => {
    if (data) {
      formik.setValues({
        name: data?.holiday_name,
        date: data?.holiday_date ? formatDate(data?.holiday_date) : '',
      })
    }
  }, [data])

  const validationSchema = Yup.object({
    name: Yup.string().required('Name is required'),
    date: Yup.string().required('Date is required'),
  })

  const handleSubmit = () => {
    dispatch(setLoader(true))
    validationSchema
      .validate(formik.values, { abortEarly: false })
      .then(async () => {
        const responseBody = {
          holiday_id: HolidayId,
          name: formik.values.name,
          date: formik.values.date,
        }
        axios
          .patch(`${baseURL}${urls.HOLIDAY_PATCH}`, responseBody)
          .then((response) => {
            if (response.status === 201 || response.status === 200) {
              toast.success('Record Updated Successfully!')
              dispatch(setLoader(false))
              dispatch(setRefreshPage(true))
              handleClose()
            } else {
              console.log('Error:', response)
              toast.error(response.error.message)
              dispatch(setLoader(false))
            }
          })
          .catch((error) => {
            console.error('Error:', error)
            if (error.response.data) {
              toast.error(error.response.data.error.message)
            }

            dispatch(setLoader(false))
          })
      })
      .catch((errors) => {
        console.log('errors', formik.errors)
        errors?.inner?.forEach((error) => {
          toast.error(error.message)
        })
        dispatch(setLoader(false))
      })
  }

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: handleSubmit,
  })

  return (
    <ModalWrapper
      open={open}
      handleClose={handleClose}
      title={'Edit Holiday'}
      width={'fit-content'}
    >
      <div className="add-employee">
        <div className="emp-det-head"></div>
        <div className="text-fields">
          <TextFields
            width={'100%'}
            label={'Name of the Holiday*'}
            name={'name'}
            value={formik.values.name}
            required
            onChange={formik.handleChange}
          />
        </div>
        <div className="text-fields">
          <DateInput
            label={'Date'}
            value={formik.values.date}
            name={'date'}
            required
            onChange={formik.handleChange}
            width={'100%'}
          />
        </div>
        <div className="add-employee-btns">
          <div className="in-a-row">
            <Typography onClick={handleClose} className="cancel-btn">
              Cancel
            </Typography>
            <StyledButton onClick={handleSubmit}>Update</StyledButton>
          </div>
        </div>
      </div>
    </ModalWrapper>
  )
}
